import { render, staticRenderFns } from "./SvgButton.vue?vue&type=template&id=df046976&scoped=true&"
import script from "./SvgButton.vue?vue&type=script&lang=js&"
export * from "./SvgButton.vue?vue&type=script&lang=js&"
import style0 from "./SvgButton.vue?vue&type=style&index=0&id=df046976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df046976",
  null
  
)

component.options.__file = "www/vues/common/controls/SvgButton.vue"
export default component.exports